import SaveHoliday from '../../services/general/HolidayCalendarCrud.api'
import { toLeaveCalendarKey } from '../../components/shared/leaveCalendarDateUtils'

export const SCHEDULER_HOLIDAY_APPOINTMENT_ERROR = 'Appointment cannot be created on Holidays'

const holidayCalendarCache = {}
const SCHEDULER_HOLIDAY_COUNTRIES = ['India', 'USA']

const normalizeSchedulerHolidayCountry = (country = '') => {
  const countryName = String(country || '').trim().toLowerCase()

  if (countryName.includes('usa') || countryName.includes('united states') || countryName === 'us') {
    return 'USA'
  }

  if (countryName.includes('india')) {
    return 'India'
  }

  return 'India'
}

export const getSchedulerHolidayCountry = (source = {}) => {
  const directCountry = source?.Country || source?.country || source?.employeeCountry || source?.countryName || source?.CountryName

  if (directCountry) {
    return normalizeSchedulerHolidayCountry(directCountry)
  }

  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}')
    return normalizeSchedulerHolidayCountry(user?.Country || user?.country || user?.employeeCountry || user?.countryName || user?.CountryName || user?.location)
  } catch {
    return 'India'
  }
}

const parseHolidayResponse = (response) => {
  let raw = response?.d ?? response

  if (typeof raw === 'string') {
    try {
      raw = JSON.parse(raw)
    } catch {
      return []
    }
  }

  if (Array.isArray(raw)) return raw
  if (Array.isArray(raw?.data)) return raw.data
  if (Array.isArray(raw?.Data)) return raw.Data

  return []
}

const loadHolidayCalendar = async (country, year) => {
  const normalizedCountry = normalizeSchedulerHolidayCountry(country)
  const selectedYear = Number(year) || new Date().getFullYear()
  const cacheKey = `${normalizedCountry}_${selectedYear}`

  if (!holidayCalendarCache[cacheKey]) {
    holidayCalendarCache[cacheKey] = SaveHoliday({
      mode: 'SELECTBYCOUNTRY',
      country: normalizedCountry,
      year: selectedYear,
    }).then(parseHolidayResponse).catch(() => [])
  }

  return holidayCalendarCache[cacheKey]
}

export const isSchedulerHolidayDate = async (dateValue, country) => {
  const targetDateKey = toLeaveCalendarKey(dateValue)
  if (!targetDateKey) return false

  const [year] = targetDateKey.split('-')
  const countriesToCheck = [...new Set([normalizeSchedulerHolidayCountry(country), ...SCHEDULER_HOLIDAY_COUNTRIES])]
  const holidayCalendars = await Promise.all(countriesToCheck.map((holidayCountry) => loadHolidayCalendar(holidayCountry, year)))

  return holidayCalendars.some((holidays) =>
    holidays.some((holiday) => {
      const holidayDate = holiday?.HolidayDate || holiday?.holidayDate || holiday?.date
      return toLeaveCalendarKey(holidayDate) === targetDateKey
    }),
  )
}
